module.exports = __webpack_public_path__ + "img/92-5000cd.png";